global.msgError = ''
// global.API_URL = 'http://172.16.3.222:5000/'

global.API_URL = 'https://server.impintsys.com/'

